export default "__VITE_ASSET__v_A1p1Bw__"